// @flow
import { anyPass, pipe, equals, when } from 'ramda';
import { logError } from './sentry';

import settings from '../settings';
import translateErrors from './i18n/errors-locale';
import {openHttpErrorAlert,sendNotifications} from "../actions/shipping"

import { jsonToSnakeCase, jsonToCamelCase } from './normalize';
import { isDefined } from './ramda';


type FetchConfig = {
  ...RequestOptions,
  body?: any,
};

type LocalResponse = {
  ...Response,
  data: any,
};

type CustomErrorType = 'BackendError';

let CSRFToken;

export function getCSRFToken(): string {
  if (CSRFToken) {
    return CSRFToken;
  }

  const meta = document.querySelector('meta[name="csrf-token"]');

  if (meta) {
    CSRFToken = meta.getAttribute('content');

    return CSRFToken || '';
  }

  return '';
}

function prepareJSONInit(init,shouldToSnake=true) {
  const update = { ...init };

  if (init.method) {
    update.method = init.method.toUpperCase();
  }

  if (init.body ) {
    update.body = JSON.stringify(shouldToSnake?jsonToSnakeCase(init.body):init.body);
  }

  return { ...init, ...update };
}

function getBaseRequest(input: RequestInfo) {
  const init = {
    credentials: 'same-origin',
    headers: new Headers({
      'X-CSRF-Token': getCSRFToken(),

      Accept: 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
    }),
  };

  return new Request(input, init);
}

function getBaseFileRequest(input: RequestInfo) {
  const init = {
    credentials: 'same-origin',
    headers: new Headers({
      'X-CSRF-Token': getCSRFToken(),
      Accept: 'application/json, text/html, */*',
    }),
  };

  return new Request(input, init);
}

function checkStatus(response) {
  const { status } = response;

  if (
    response.status === 401 &&
    !window.location.href.includes(settings.path.login)
  ) {
    window.location.reload();
  }

  if (
    (status >= 200 && status < 300) ||
    status === 400 ||
    status === 422 ||
    status === 304 ||
    status === 409
  ) {
    return response;
  }

  const error = new Error(`${response.statusText} (${response.url})`);

  // $FlowFixMe
  error.response = response;

  throw error;
}

function checkStatusAndAlertError(response,dispatch,finalFormUsed) {
  const { status,statusText,url,error} = response;
 
  if (
    (status >= 200 && status < 300) ||
    status === 400 ||
    // status === 422 ||
    status === 304 ||
    status === 409
  ) {
    return response;
  }

  let errorMessage=""
  // let errorMessage=(status+" ")

  return response?.json().then(data => {
   

    if (status===404) {
      errorMessage += "Page Not Found";
    }else if (status===403) {
      errorMessage +=(statusText+" "+data?.error||"Page Not Found");
    }else if (status===422) {
      errorMessage +=((data?.errors||[]).map(x=>x?.message||"").join(","));
    } else if (status===423) {
       errorMessage +=( statusText||"Failed to fetch data") +" "+(data?.error||"")
    } else if (status===500) {
      // errorMessage +=( statusText)
    } 
    const {error}=data;
    if(error){
      errorMessage +=(" "+error)
    }
    // errorMessage +=(" "+url)
    dispatch(sendNotifications({notifications:[{
      message:errorMessage,
      type:"error",
      id:Math.random()
    }]}))
    // if(status===500){
    //   dispatch(sendNotifications({notifications:[{
    //     message:errorMessage,
    //     type:"error",
    //     id:Math.random()
    //   }]}))
    // }else{
    //   dispatch(openHttpErrorAlert(errorMessage))
    // }
  

    if (!finalFormUsed ) {
        const err = new Error(`${response.statusText} (${response.url})`);
        err.response = response;
        throw err;
    }
   
  })
  .catch(jsonError => {
    // 捕获无法解析为 JSON 的错误
    errorMessage +=("Internal Server Error"+(" "+url))
    // dispatch(openHttpErrorAlert(errorMessage))
    throw jsonError;
   
    // return response?.text().then(text => {
    //   // 自定义错误消息：告知用户响应不是 JSON 格式
    //   const errorMessage = `Received non-JSON response: ${text.substring(0, 100)}...`;
    //   dispatch(openHttpErrorAlert(errorMessage));
    //   const parsingError = new Error('Response is not in JSON format');
    //   parsingError.response = response;
    //   throw parsingError;
    // }).catch(textError => {
    //   // 如果 response.text() 也失败了
    //   const finalError = new Error('Failed to read response text');
    //   finalError.response = response;
    //   throw finalError;
    // });
  });
 
}

function parseJSON(response): Promise<LocalResponse> {
  return response
    .text()
    .then((data) => {
      if (data.length === 0) {
        // $FlowFixMe
        return Object.assign(response, { data: {} });
      }

      try {
        const parsedJSON = JSON.parse(data);
        // $FlowFixMe
        return Object.assign(response, {
          data: jsonToCamelCase(parsedJSON),
        });
      } catch (error) {
        logError(error, { extra: data });
        return Promise.reject(error);
      }
    })
    .catch((error) => {
      throw Object.assign(error, { response });
    });
}

const SHIPPING_PROFILE_RESYNC_FAILURE ="shipping profile resync failure"

function parseJSONWithNoDataField(response,dispatch,isShippingProfileResync): Promise<LocalResponse> {
  return response?.text()
    .then((data) => {
     try {
      let result=JSON.parse(data)
      if(isShippingProfileResync){
        const { resync_result } = result
        if((resync_result==1)||(resync_result==3)){
          return result;
        }else{
          dispatch(sendNotifications({notifications:[{
            message:SHIPPING_PROFILE_RESYNC_FAILURE,
            type:"error",
            id:Math.random()
          }]}))
          // dispatch(openHttpErrorAlert(SHIPPING_PROFILE_RESYNC_FAILURE))
          throw new Error(SHIPPING_PROFILE_RESYNC_FAILURE)
        }
      }else{
        return result;
      }

     } catch (error) {
     }
    })
    .catch((error) => {
      throw error
    });
}

export function fetchJSON(
  input: RequestInfo,
  config: FetchConfig = {}
): Promise<LocalResponse> {
  return fetch(getBaseRequest(input), prepareJSONInit(config))
    .then(checkStatus)
    .then((response) => parseJSON(response));
}

export function fetchJSONWithErrorAlert(
  input: RequestInfo,
  config: FetchConfig = {},
  dispatch,
  finalFormUsed,
  isShippingProfileResync=false
): Promise<LocalResponse> {
  return fetch(getBaseRequest(input), prepareJSONInit(config,false))
    .then(response=>checkStatusAndAlertError(response, dispatch,finalFormUsed))
    .then((response) => parseJSONWithNoDataField(response,dispatch,isShippingProfileResync));
}

export function fetchFile(
  input: RequestInfo,
  config: FetchConfig = {}
): Promise<LocalResponse> {
  return fetch(getBaseFileRequest(input), config)
    .then(checkStatus)
    .then((response) => parseJSON(response));
}

function namedError(name: string, message: string): Error {
  const error = new Error(message);
  error.name = name;
  return error;
}

const validateResponse = ({
  ok,
  data,
}: LocalResponse): Promise<LocalResponse> => {
  if (ok) {
    return Promise.resolve(data);
  }

  let errorMessage = translateErrors('generic_error');

  if (data.error) {
    errorMessage = data.error;
  } else if (data.errors) {
    const errorsArr = Array.isArray(data.errors)
      ? data.errors
      : Object.values(data.errors);
    errorMessage = errorsArr.join(', ');
  }

  throw namedError('BackendError', errorMessage);
};

export function fetchJSONWithValidation(
  input: RequestInfo,
  config: FetchConfig
): Promise<LocalResponse> {
  return fetchJSON(input, config).then(validateResponse);
}

export function isCustomError(
  error: Error,
  type: CustomErrorType = 'BackendError'
): boolean {
  return error.name === type;
}

// ------- http skip errors -------
const MOZILLA_CANCEL_ERROR =
  'TypeError: NetworkError when attempting to fetch resource.';

const getErrorString: any = (error) => error.toString();

export const checkIsEscapeError: (error?: Error) => boolean | null = when<
  any,
  any,
  any
>(isDefined, pipe(getErrorString, anyPass([equals(MOZILLA_CANCEL_ERROR)])));
